/**
 * In the page there should be one or more listings [data-container-loadmore] with the functionality of the load more [data-pagination-button];
 * At the click of the load more button of the listing referenced by its ID, it executes a fetch call in GET
 * The resolution of the PROMISE of the fetch transforms the data into a text with the PROMISE Text()
 * The resolution of the PROMISE Text() gives us the result NOT parsed.
 * At this point we will instantiate a DOM Parser, so that it allows us to parse our result in text / html
 * We take only the elements we want [data-to-append]
 * We verify that the listing to which we will hang the elements received is related to the Load more button clicked
 * I append the elements to the listing.
 *
 * At this point, the button will update with the new href
 * If it doesn't have an href, the button node will be removed
 *
 * */
const initPaginationComponent = () => {
    const buttonsArray = document.querySelectorAll("[data-pagination-button]");
    const dataContainersArray = document.querySelectorAll("[data-container-loadmore]");
    const paginationComponentsArray = document.querySelectorAll("[data-pagination-component]");
    const loader = document.querySelector("[data-loader]");
    if (loader && buttonsArray && dataContainersArray && buttonsArray.length > 0 && dataContainersArray.length > 0) {
        // Put unique id on data container
        dataContainersArray.forEach((dataContainer, index) => {
            dataContainer.setAttribute("data-container-loadmore", index.toString());
            dataContainer.style.height = dataContainer.getBoundingClientRect().height.toString();
        });
        // Put unique id on pagination component
        paginationComponentsArray.forEach((dataContainer, index) => {
            dataContainer.setAttribute("data-pagination-component", index.toString());
        });
        buttonsArray.forEach((button, index) => {
            button.addEventListener("click", (event) => {
                //stop "anchor click" default behaviour
                event.preventDefault();
                //display it
                loader.classList.add("active");
                //fade pagination
                button.closest("[data-pagination-component]").classList.remove("active");
                //fetch new page
                fetch(`${button.href}`)
                    .then(data => {
                    //hide old pagination
                    const oldPaginationComponent = document.querySelector("[data-pagination-component]");
                    oldPaginationComponent.classList.remove("active");
                    //convert the response into plain text
                    data.text()
                        //resolve the promise
                        .then((result) => {
                        // Initialize the DOM parser
                        const parser = new DOMParser();
                        // Parse the text and convert it into HTML
                        const parsedHTML = parser.parseFromString(result, "text/html");
                        //get only the cards
                        const cardsToAppendArray = parsedHTML.querySelectorAll("[data-to-append]");
                        //get the correct component id
                        const paginationComponentId = button.closest("[data-pagination-component]").getAttribute("data-pagination-component");
                        //if the id matches
                        const dataContainer = document.querySelector(`[data-container-loadmore='${paginationComponentId}']`);
                        //proceed to empty the deck
                        dataContainer.querySelectorAll("[data-to-append]").forEach(card => {
                            card.remove();
                        });
                        //finally load the new cards
                        cardsToAppendArray.forEach(card => {
                            dataContainer.append(card);
                        });
                        //add animation
                        const configCardsAnimationLoadMore = new ConfigCardsAnimation();
                        configCardsAnimationLoadMore.delay = 300;
                        configCardsAnimationLoadMore.cardsToAnimateNodeList = cardsToAppendArray;
                        const cardAnimationLoadMore = new CardAnimation;
                        cardAnimationLoadMore.initCardsAnimation(configCardsAnimationLoadMore);
                        //print new pagination
                        const newPaginationComponent = parsedHTML.querySelector("[data-pagination-component]");
                        newPaginationComponent.setAttribute("data-pagination-component", paginationComponentId);
                        oldPaginationComponent.innerHTML = newPaginationComponent.innerHTML;
                        //bind the events again
                        initPaginationComponent();
                        //scroll to deck start
                        dataContainer.scrollIntoView();
                        //hide loader
                        loader.classList.remove("active");
                    });
                });
            });
        });
    }
};
